"use strict";
exports.__esModule = true;
exports.sharedRoot = void 0;
exports.sharedRoot = {
    fontFamily: 'Menlo, Monaco, "Courier New", monospace',
    fontFeatureSettings: '"liga" 0, "calt" 0',
    lineHeight: '1.5em',
    whiteSpace: 'pre',
    margin: 0
};
